var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('talent-details',{attrs:{"position":_vm.position,"hero":_vm.hero,"withAttributes":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }